// src/settings/SettingsShell.jsx
import React from "react";
import './Settings.css'
export default function SettingsShell({
  tabs,
  activeTabId,
  onTabChange,
  RightComponent,
  rightTitle,
}) {
  return (
    <div className="settingsPage">
      <aside className="settingsSidebar">

        <nav className="settingsNav" aria-label="Settings sections">
          {tabs.map((tab) => {
            const isActive = tab.id === activeTabId;
            return (
              <button
                key={tab.id}
                type="button"
                className={`settingsNav__item ${isActive ? "isActive" : ""}`}
                onClick={() => onTabChange(tab.id)}
              >
                {tab.title}
              </button>
            );
          })}
        </nav>
      </aside>

      <main className="settingsMain">
        <header className="settingsHeader">
          <h1 className="settingsHeader__title">{rightTitle}</h1>
        </header>

        <section className="settingsContent">
          <RightComponent />
        </section>
      </main>
    </div>
  );
}